import React from 'react';

import { FineDetails, OrderSummaryText, StyledLine } from '../style';

type PaymentItemProms = {
    item: string;
    amount: string;
    last?: boolean;
};

export default function PaymentItem({ item, amount, last }: PaymentItemProms) {
    return (
        <>
            <FineDetails>
                <OrderSummaryText>{item}</OrderSummaryText>
                <OrderSummaryText> 
                    {amount}
                </OrderSummaryText>
            </FineDetails>
            {last && <StyledLine />}
        </>
    );
}
